"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavTabs = _interopRequireWildcard(require("../NavTabs"));

var TabsDefaultLayout = function TabsDefaultLayout(_ref) {
  var stretch = _ref.stretch,
      nav = _ref.nav,
      tab = _ref.tab;
  return _react.default.createElement("div", null, nav, tab);
};

var Tabs =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Tabs, _PureComponent);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      index: _this.props.defaultTabIndex || 0
    });
    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "renderNav",
    value: function renderNav() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      return _react.default.createElement(_NavTabs.default, {
        stretch: true,
        className: className
      }, _react.default.Children.toArray(children).map(function (child, index) {
        var _child$props = child.props,
            name = _child$props.name,
            Icon = _child$props.Icon;
        return _react.default.createElement(_NavTabs.NavTab, {
          key: index,
          active: index === _this2.state.index,
          onClick: function onClick() {
            return _this2.setState({
              index: index
            });
          },
          Icon: Icon
        }, name);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          Layout = _this$props2.Layout,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["Layout"]);

      var tab = _react.default.Children.toArray(this.props.children)[this.state.index];

      var nav = this.renderNav();
      return _react.default.createElement(Layout, (0, _extends2.default)({}, props, {
        tab: tab,
        nav: nav
      }));
    }
  }]);
  return Tabs;
}(_react.PureComponent);

exports.default = Tabs;
(0, _defineProperty2.default)(Tabs, "defaultProps", {
  Layout: TabsDefaultLayout
});
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  Layout: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_react.Component), _propTypes.default.func]),
  defaultTabIndex: _propTypes.default.number,
  className: _propTypes.default.string
} : {};

var Tab = function Tab(_ref2) {
  var children = _ref2.children;
  return children;
};

exports.Tab = Tab;
Tab.propTypes = {
  name: _propTypes.default.node.isRequired,
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)])
};